import { Component, Vue } from 'vue-property-decorator';

import FundingOption from './option/option.vue';

@Component({
    components: {
        FundingOption,
    },
})
export default class Funding extends Vue {
    document: any = null;

    mounted() {
        this.getData();
    }

    async getData() {
        const document = await this.$prismic.client.getSingle('funding_options');

        this.document = document;

        this.$emit('load');
    }
}
